
// // import React, { useEffect, useRef, useState } from "react";
// // import { Link, useLocation } from "react-router-dom";
// // import {
// //   Menu,
// //   X,
// //   ChevronDown,
// //   ArrowUpRight,
// //   Shield,
// //   BookOpen,
// //   Landmark,
// //   Home,
// //   ShieldCheck,
// //   Cpu,
// // } from "lucide-react";

// // import LOGO from "../../src/assets/logolmsbts3.png";

// // const solutionItems = [
// //   { label: "Healthcare", href: "/solutions/healthcare", icon: Shield },
// //   { label: "Education", href: "/solutions/education", icon: BookOpen },
// //   { label: "Banking & Finance", href: "/solutions/banking-finance", icon: Landmark },
// //   { label: "Real Estate", href: "/solutions/real-estate", icon: Home },
// //   { label: "Insurance", href: "/solutions/insurance", icon: ShieldCheck },
// //   { label: "Technology", href: "/solutions/technology", icon: Cpu },
// // ];

// // const navItems = [
// //   { label: "Features", path: "/features" },
// //   { label: "Solutions", path: "/solutions", dropdown: true },
// //   { label: "Pricing", path: "/pricing" },
// //   { label: "About Us", path: "/about-us" },
// //   { label: "Contact Us", path: "/contact" },
// // ];

// // const PublicHeader = () => {
// //   const location = useLocation();
// //   const headerRef = useRef(null);

// //   const [scrolled, setScrolled] = useState(false);
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);
// //   const [mobileSolutionsOpen, setMobileSolutionsOpen] = useState(false);

// //   const isActive = (path) => {
// //     if (path === "/") return location.pathname === "/";
// //     return (
// //       location.pathname === path ||
// //       location.pathname.startsWith(`${path}/`)
// //     );
// //   };

// //   useEffect(() => {
// //     const handleScroll = () => setScrolled(window.scrollY > 8);
// //     handleScroll();
// //     window.addEventListener("scroll", handleScroll, { passive: true });
// //     return () => window.removeEventListener("scroll", handleScroll);
// //   }, []);

// //   useEffect(() => {
// //     setIsMenuOpen(false);
// //     setIsSolutionsOpen(false);
// //     setMobileSolutionsOpen(false);
// //   }, [location.pathname]);

// //   useEffect(() => {
// //     document.body.style.overflow = isMenuOpen ? "hidden" : "";
// //     return () => {
// //       document.body.style.overflow = "";
// //     };
// //   }, [isMenuOpen]);

// //   useEffect(() => {
// //     const handleOutsideClick = (event) => {
// //       if (headerRef.current && !headerRef.current.contains(event.target)) {
// //         setIsSolutionsOpen(false);
// //       }
// //     };
// //     document.addEventListener("mousedown", handleOutsideClick);
// //     return () => document.removeEventListener("mousedown", handleOutsideClick);
// //   }, []);

// //   const closeMobileMenu = () => {
// //     setIsMenuOpen(false);
// //     setMobileSolutionsOpen(false);
// //   };

// //   return (
// //     <>
// //       <header
// //         ref={headerRef}
// //         className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
// //           scrolled
// //             ? "bg-white/90 shadow-[0_4px_24px_rgba(40,25,79,0.06)] backdrop-blur-xl"
// //             : "bg-white border-b border-slate-100"
// //         }`}
// //       >
// //         {/* Thin brand accent */}
// //         <div className="h-[2px] w-full bg-gradient-to-r from-[#28194f] via-[#48247f] to-[#702cb0]" />

// //         <nav
// //           className="mx-auto flex h-[60px] w-full max-w-[1600px] items-center justify-between px-4 sm:px-6 lg:h-[66px] lg:px-8 xl:px-12"
// //           aria-label="Main navigation"
// //         >
// //           {/* Logo */}
// //           <Link
// //             to="/"
// //             className="relative z-50 flex shrink-0 items-center rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2"
// //             aria-label="LMSBOTS home"
// //           >
// //             <img
// //               src={LOGO}
// //               alt="LMSBOTS"
// //               className="h-8 w-auto object-contain sm:h-9 lg:h-[38px]"
// //             />
// //           </Link>

// //           {/* Desktop navigation */}
// //           <div className="hidden items-center gap-1 lg:flex">
// //             {navItems.map((item) => {
// //               if (item.dropdown) {
// //                 return (
// //                   <div className="relative" key={item.label}>
// //                     <button
// //                       type="button"
// //                       onClick={() => setIsSolutionsOpen((open) => !open)}
// //                       onMouseEnter={() => setIsSolutionsOpen(true)}
// //                       aria-expanded={isSolutionsOpen}
// //                       className={`group inline-flex items-center gap-1 rounded-lg px-3 py-2 text-[13.5px] font-medium tracking-tight transition-colors ${
// //                         isSolutionsOpen || isActive(item.path)
// //                           ? "text-[#48247f]"
// //                           : "text-slate-600 hover:text-[#48247f]"
// //                       }`}
// //                     >
// //                       {item.label}
// //                       <ChevronDown
// //                         size={14}
// //                         strokeWidth={2.25}
// //                         className={`text-current/60 transition-transform duration-200 ${
// //                           isSolutionsOpen ? "rotate-180" : ""
// //                         }`}
// //                       />
// //                     </button>

// //                     {isSolutionsOpen && (
// //                       <div
// //                         onMouseLeave={() => setIsSolutionsOpen(false)}
// //                         className="absolute left-1/2 top-full z-50 mt-2 w-[360px] -translate-x-1/2 overflow-hidden rounded-xl border border-slate-200/70 bg-white p-1.5 shadow-[0_16px_48px_rgba(40,25,79,0.12)] animate-in fade-in slide-in-from-top-1 duration-150"
// //                       >
// //                         <div className="grid grid-cols-2 gap-0.5">
// //                           {solutionItems.map((solution) => {
// //                             const Icon = solution.icon;
// //                             return (
// //                               <Link
// //                                 key={solution.label}
// //                                 to={solution.href}
// //                                 onClick={() => setIsSolutionsOpen(false)}
// //                                 className="group flex items-center gap-2.5 rounded-lg px-2.5 py-2 transition-colors hover:bg-slate-50"
// //                               >
// //                                 <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-slate-100 bg-white text-[#48247f] transition-colors group-hover:border-[#48247f]/15 group-hover:bg-[#f3edff]">
// //                                   <Icon size={14} strokeWidth={2} />
// //                                 </span>
// //                                 <span className="text-[13px] font-medium tracking-tight text-slate-700 group-hover:text-[#48247f]">
// //                                   {solution.label}
// //                                 </span>
// //                               </Link>
// //                             );
// //                           })}
// //                         </div>
// //                       </div>
// //                     )}
// //                   </div>
// //                 );
// //               }

// //               return (
// //                 <Link
// //                   key={item.label}
// //                   to={item.path}
// //                   className={`relative rounded-lg px-3 py-2 text-[13.5px] font-medium tracking-tight transition-colors ${
// //                     isActive(item.path)
// //                       ? "text-[#48247f]"
// //                       : "text-slate-600 hover:text-[#48247f]"
// //                   }`}
// //                 >
// //                   {item.label}
// //                   <span
// //                     className={`absolute inset-x-3 -bottom-0.5 h-[2px] rounded-full bg-gradient-to-r from-[#48247f] to-[#702cb0] transition-all duration-300 ${
// //                       isActive(item.path) ? "opacity-100" : "opacity-0"
// //                     }`}
// //                   />
// //                 </Link>
// //               );
// //             })}
// //           </div>

// //           {/* Desktop actions */}
// //           <div className="hidden shrink-0 items-center gap-1.5 lg:flex">
// //             <Link
// //               to="/login"
// //               className="rounded-lg px-3 py-2 text-[13.5px] font-medium tracking-tight text-slate-600 transition-colors hover:text-[#48247f]"
// //             >
// //               Sign in
// //             </Link>

// //             <Link
// //               to="/register"
// //               className="group inline-flex items-center gap-1.5 rounded-lg bg-[#12dfbd] px-3.5 py-2 text-[13.5px] font-semibold tracking-tight text-[#102b37] shadow-[0_2px_8px_rgba(18,223,189,0.25)] transition-all duration-200 hover:bg-[#40f0d3] hover:shadow-[0_4px_14px_rgba(18,223,189,0.35)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2"
// //             >
// //               Get started
// //               <ArrowUpRight
// //                 size={14}
// //                 strokeWidth={2.5}
// //                 className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
// //               />
// //             </Link>
// //           </div>

// //           {/* Mobile toggle */}
// //           <button
// //             type="button"
// //             onClick={() => setIsMenuOpen((open) => !open)}
// //             className="relative z-50 flex h-9 w-9 items-center justify-center rounded-lg text-slate-700 transition-colors hover:bg-slate-100 hover:text-[#48247f] lg:hidden"
// //             aria-label={isMenuOpen ? "Close navigation" : "Open navigation"}
// //             aria-expanded={isMenuOpen}
// //           >
// //             {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
// //           </button>
// //         </nav>
// //       </header>

// //       {/* Mobile backdrop */}
// //       <div
// //         onClick={closeMobileMenu}
// //         className={`fixed inset-0 z-40 bg-slate-950/30 backdrop-blur-[2px] transition-opacity duration-300 lg:hidden ${
// //           isMenuOpen ? "visible opacity-100" : "invisible opacity-0"
// //         }`}
// //       />

// //       {/* Mobile navigation */}
// //       <aside
// //         className={`fixed bottom-0 right-0 top-0 z-40 flex w-full max-w-[360px] flex-col bg-white shadow-2xl transition-transform duration-300 ease-out lg:hidden ${
// //           isMenuOpen ? "translate-x-0" : "translate-x-full"
// //         }`}
// //         aria-hidden={!isMenuOpen}
// //       >
// //         <div className="h-[2px] shrink-0 bg-gradient-to-r from-[#28194f] via-[#48247f] to-[#702cb0]" />

// //         <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3.5">
// //           <img src={LOGO} alt="LMSBOTS" className="h-8 w-auto object-contain" />
// //           <button
// //             type="button"
// //             onClick={closeMobileMenu}
// //             className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-600 transition-colors hover:bg-slate-100 hover:text-[#48247f]"
// //             aria-label="Close menu"
// //           >
// //             <X size={19} />
// //           </button>
// //         </div>

// //         <div className="flex-1 overflow-y-auto px-3 py-4">
// //           {navItems.map((item) => {
// //             if (item.dropdown) {
// //               return (
// //                 <div key={item.label}>
// //                   <button
// //                     type="button"
// //                     onClick={() => setMobileSolutionsOpen((open) => !open)}
// //                     className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left text-[14px] font-medium tracking-tight text-slate-700 transition-colors hover:bg-slate-50 hover:text-[#48247f]"
// //                   >
// //                     Solutions
// //                     <ChevronDown
// //                       size={16}
// //                       strokeWidth={2.25}
// //                       className={`transition-transform duration-200 ${
// //                         mobileSolutionsOpen ? "rotate-180" : ""
// //                       }`}
// //                     />
// //                   </button>

// //                   <div
// //                     className={`overflow-hidden transition-all duration-300 ${
// //                       mobileSolutionsOpen
// //                         ? "max-h-[400px] opacity-100"
// //                         : "max-h-0 opacity-0"
// //                     }`}
// //                   >
// //                     <div className="ml-2 mt-1 space-y-0.5 border-l border-slate-200 pl-2">
// //                       {solutionItems.map((solution) => {
// //                         const Icon = solution.icon;
// //                         return (
// //                           <Link
// //                             key={solution.label}
// //                             to={solution.href}
// //                             onClick={closeMobileMenu}
// //                             className="flex items-center gap-2.5 rounded-lg px-3 py-2 text-[13px] text-slate-600 transition-colors hover:bg-[#f3edff] hover:text-[#48247f]"
// //                           >
// //                             <Icon size={15} />
// //                             {solution.label}
// //                           </Link>
// //                         );
// //                       })}
// //                     </div>
// //                   </div>
// //                 </div>
// //               );
// //             }

// //             return (
// //               <Link
// //                 key={item.label}
// //                 to={item.path}
// //                 onClick={closeMobileMenu}
// //                 className={`block rounded-lg px-3 py-2.5 text-[14px] font-medium tracking-tight transition-colors ${
// //                   isActive(item.path)
// //                     ? "bg-slate-50 text-[#48247f]"
// //                     : "text-slate-700 hover:bg-slate-50 hover:text-[#48247f]"
// //                 }`}
// //               >
// //                 {item.label}
// //               </Link>
// //             );
// //           })}
// //         </div>

// //         <div className="border-t border-slate-100 p-4">
// //           <div className="grid grid-cols-2 gap-2">
// //             <Link
// //               to="/login"
// //               onClick={closeMobileMenu}
// //               className="flex items-center justify-center rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-[13.5px] font-medium text-slate-700 transition-colors hover:border-[#48247f]/30 hover:text-[#48247f]"
// //             >
// //               Sign in
// //             </Link>
// //             <Link
// //               to="/register"
// //               onClick={closeMobileMenu}
// //               className="flex items-center justify-center gap-1.5 rounded-lg bg-[#12dfbd] px-3 py-2.5 text-[13.5px] font-semibold text-[#102b37] shadow-[0_2px_8px_rgba(18,223,189,0.25)] transition-all hover:bg-[#40f0d3]"
// //             >
// //               Get started
// //               <ArrowUpRight size={14} strokeWidth={2.5} />
// //             </Link>
// //           </div>
// //         </div>
// //       </aside>
// //     </>
// //   );
// // };

// // export default PublicHeader;







// import React, { useEffect, useRef, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import {
//   Menu,
//   X,
//   ChevronDown,
//   ArrowUpRight,
//   Shield,
//   BookOpen,
//   Landmark,
//   Home,
//   ShieldCheck,
//   Cpu,
// } from "lucide-react";

// import LOGO from "../../src/assets/logolmsbts3.png";

// const solutionItems = [
//   { label: "Healthcare", href: "/solutions/healthcare", icon: Shield },
//   { label: "Education", href: "/solutions/education", icon: BookOpen },
//   { label: "Banking & Finance", href: "/solutions/banking-finance", icon: Landmark },
//   { label: "Real Estate", href: "/solutions/real-estate", icon: Home },
//   { label: "Insurance", href: "/solutions/insurance", icon: ShieldCheck },
//   { label: "Technology", href: "/solutions/technology", icon: Cpu },
// ];

// const navItems = [
//   { label: "Features", path: "/features" },
//   { label: "Solutions", path: "/solutions", dropdown: true },
//   { label: "Pricing", path: "/pricing" },
//   { label: "About Us", path: "/about-us" },
//   { label: "Contact Us", path: "/contact" },
// ];

// const PublicHeader = () => {
//   const location = useLocation();
//   const headerRef = useRef(null);

//   const [scrolled, setScrolled] = useState(false);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);
//   const [mobileSolutionsOpen, setMobileSolutionsOpen] = useState(false);

//   const isActive = (path) => {
//     if (path === "/") return location.pathname === "/";
//     return (
//       location.pathname === path ||
//       location.pathname.startsWith(`${path}/`)
//     );
//   };

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 8);
//     handleScroll();
//     window.addEventListener("scroll", handleScroll, { passive: true });
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   useEffect(() => {
//     setIsMenuOpen(false);
//     setIsSolutionsOpen(false);
//     setMobileSolutionsOpen(false);
//   }, [location.pathname]);

//   useEffect(() => {
//     document.body.style.overflow = isMenuOpen ? "hidden" : "";
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [isMenuOpen]);

//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (headerRef.current && !headerRef.current.contains(event.target)) {
//         setIsSolutionsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleOutsideClick);
//     return () => document.removeEventListener("mousedown", handleOutsideClick);
//   }, []);

//   const closeMobileMenu = () => {
//     setIsMenuOpen(false);
//     setMobileSolutionsOpen(false);
//   };

//   return (
//     <>
//       <header
//         ref={headerRef}
//         className={`fixed inset-x-0 top-0 z-50 font-[Inter,ui-sans-serif,system-ui,sans-serif] antialiased transition-all duration-300 ${
//           scrolled
//             ? "bg-white/90 shadow-[0_4px_24px_rgba(40,25,79,0.08)] backdrop-blur-xl"
//             : "bg-white border-b border-slate-100"
//         }`}
//       >
//         {/* Thin brand accent with subtle glow */}
//         <div className="h-[2.5px] w-full bg-gradient-to-r from-[#28194f] via-[#48247f] to-[#702cb0] shadow-[0_0_8px_rgba(72,36,127,0.35)]" />

//         <nav
//           className="mx-auto flex h-[60px] w-full max-w-[1600px] items-center justify-between px-4 sm:px-6 lg:h-[68px] lg:px-8 xl:px-12"
//           aria-label="Main navigation"
//         >
//           {/* Logo + wordmark lockup */}
//           <Link
//             to="/"
//             className="group relative z-50 flex shrink-0 items-center gap-2 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2"
//             aria-label="LMSBOTS home"
//           >
//             <img
//               src={LOGO}
//               alt="LMSBOTS"
//               className="h-8 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.04] sm:h-9 lg:h-[38px]"
//             />
//             <span className="hidden flex-col leading-none sm:flex">
              
              
              
//             </span>
//           </Link>

//           {/* Desktop navigation */}
//           <div className="hidden items-center gap-0.5 lg:flex">
//             {navItems.map((item) => {
//               if (item.dropdown) {
//                 return (
//                   <div className="relative" key={item.label}>
//                     <button
//                       type="button"
//                       onClick={() => setIsSolutionsOpen((open) => !open)}
//                       onMouseEnter={() => setIsSolutionsOpen(true)}
//                       aria-expanded={isSolutionsOpen}
//                       className={`group relative inline-flex items-center gap-1 rounded-lg px-3.5 py-2 text-[14px] font-semibold tracking-[0.01em] transition-colors ${
//                         isSolutionsOpen || isActive(item.path)
//                           ? "text-[#48247f]"
//                           : "text-slate-600 hover:text-[#48247f]"
//                       }`}
//                     >
//                       <span className="relative">
//                         {item.label}
//                         <span
//                           className={`absolute -bottom-1 left-0 h-[2px] rounded-full bg-gradient-to-r from-[#48247f] to-[#702cb0] transition-all duration-300 ${
//                             isSolutionsOpen || isActive(item.path)
//                               ? "w-full opacity-100"
//                               : "w-0 opacity-0 group-hover:w-full group-hover:opacity-100"
//                           }`}
//                         />
//                       </span>
//                       <ChevronDown
//                         size={15}
//                         strokeWidth={2.5}
//                         className={`text-current/60 transition-transform duration-200 ${
//                           isSolutionsOpen ? "rotate-180" : ""
//                         }`}
//                       />
//                     </button>

//                     {isSolutionsOpen && (
//                       <div
//                         onMouseLeave={() => setIsSolutionsOpen(false)}
//                         className="absolute left-1/2 top-full z-50 mt-2 w-[380px] -translate-x-1/2 overflow-hidden rounded-2xl border border-slate-200/70 bg-white p-2 shadow-[0_20px_60px_rgba(40,25,79,0.15)] animate-in fade-in slide-in-from-top-1 duration-150"
//                       >
//                         <div className="grid grid-cols-2 gap-1">
//                           {solutionItems.map((solution) => {
//                             const Icon = solution.icon;
//                             return (
//                               <Link
//                                 key={solution.label}
//                                 to={solution.href}
//                                 onClick={() => setIsSolutionsOpen(false)}
//                                 className="group flex items-center gap-2.5 rounded-xl px-3 py-2.5 transition-all duration-200 hover:bg-[#f6f2ff]"
//                               >
//                                 <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-slate-100 bg-white text-[#48247f] shadow-sm transition-all duration-200 group-hover:-translate-y-0.5 group-hover:border-[#48247f]/20 group-hover:bg-gradient-to-br group-hover:from-[#f3edff] group-hover:to-[#e9deff] group-hover:shadow-md">
//                                   <Icon size={15} strokeWidth={2.25} />
//                                 </span>
//                                 <span className="text-[13.5px] font-semibold tracking-[0.005em] text-slate-700 transition-colors group-hover:text-[#48247f]">
//                                   {solution.label}
//                                 </span>
//                               </Link>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 );
//               }

//               return (
//                 <Link
//                   key={item.label}
//                   to={item.path}
//                   className={`group relative rounded-lg px-3.5 py-2 text-[14px] font-semibold tracking-[0.01em] transition-colors ${
//                     isActive(item.path)
//                       ? "text-[#48247f]"
//                       : "text-slate-600 hover:text-[#48247f]"
//                   }`}
//                 >
//                   <span className="relative">
//                     {item.label}
//                     <span
//                       className={`absolute -bottom-1 left-0 h-[2px] rounded-full bg-gradient-to-r from-[#48247f] to-[#702cb0] transition-all duration-300 ${
//                         isActive(item.path)
//                           ? "w-full opacity-100"
//                           : "w-0 opacity-0 group-hover:w-full group-hover:opacity-100"
//                       }`}
//                     />
//                   </span>
//                 </Link>
//               );
//             })}
//           </div>

//           {/* Desktop actions */}
//           <div className="hidden shrink-0 items-center gap-2 lg:flex">
//             <Link
//               to="/login"
//               className="rounded-lg px-3.5 py-2 text-[14px] font-semibold tracking-[0.01em] text-slate-600 transition-colors hover:text-[#48247f]"
//             >
//               Sign in
//             </Link>

//             <Link
//               to="/register"
//               className="group relative inline-flex items-center gap-1.5 overflow-hidden rounded-lg bg-[#12dfbd] px-4 py-2 text-[14px] font-bold tracking-[0.015em] text-[#102b37] shadow-[0_2px_10px_rgba(18,223,189,0.3)] transition-all duration-200 hover:bg-[#40f0d3] hover:shadow-[0_6px_20px_rgba(18,223,189,0.45)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2"
//             >
//               {/* Shimmer overlay */}
//               <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
//               <span className="relative">Get started</span>
//               <ArrowUpRight
//                 size={15}
//                 strokeWidth={2.75}
//                 className="relative transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
//               />
//             </Link>
//           </div>

//           {/* Mobile toggle */}
//           <button
//             type="button"
//             onClick={() => setIsMenuOpen((open) => !open)}
//             className="relative z-50 flex h-9 w-9 items-center justify-center rounded-lg text-slate-700 transition-colors hover:bg-slate-100 hover:text-[#48247f] lg:hidden"
//             aria-label={isMenuOpen ? "Close navigation" : "Open navigation"}
//             aria-expanded={isMenuOpen}
//           >
//             {isMenuOpen ? <X size={20} strokeWidth={2.25} /> : <Menu size={20} strokeWidth={2.25} />}
//           </button>
//         </nav>
//       </header>

//       {/* Mobile backdrop */}
//       <div
//         onClick={closeMobileMenu}
//         className={`fixed inset-0 z-40 bg-slate-950/40 backdrop-blur-[3px] transition-opacity duration-300 lg:hidden ${
//           isMenuOpen ? "visible opacity-100" : "invisible opacity-0"
//         }`}
//       />

//       {/* Mobile navigation */}
//       <aside
//         className={`fixed bottom-0 right-0 top-0 z-40 flex w-full max-w-[360px] flex-col bg-white font-[Inter,ui-sans-serif,system-ui,sans-serif] shadow-2xl transition-transform duration-300 ease-out lg:hidden ${
//           isMenuOpen ? "translate-x-0" : "translate-x-full"
//         }`}
//         aria-hidden={!isMenuOpen}
//       >
//         <div className="h-[2.5px] shrink-0 bg-gradient-to-r from-[#28194f] via-[#48247f] to-[#702cb0]" />

//         <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3.5">
//           <div className="flex items-center gap-2">
//             <img src={LOGO} alt="LMSBOTS" className="h-8 w-auto object-contain" />
//             <div className="flex flex-col leading-none">
              
//               <span className="mt-[3px] text-[8.5px] font-semibold uppercase tracking-[0.18em] text-slate-400">
//                 AI Platform
//               </span>
//             </div>
//           </div>
//           <button
//             type="button"
//             onClick={closeMobileMenu}
//             className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-600 transition-colors hover:bg-slate-100 hover:text-[#48247f]"
//             aria-label="Close menu"
//           >
//             <X size={19} strokeWidth={2.25} />
//           </button>
//         </div>

//         <div className="flex-1 overflow-y-auto px-3 py-4">
//           {navItems.map((item) => {
//             if (item.dropdown) {
//               return (
//                 <div key={item.label}>
//                   <button
//                     type="button"
//                     onClick={() => setMobileSolutionsOpen((open) => !open)}
//                     className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left text-[14.5px] font-semibold tracking-[0.01em] text-slate-700 transition-colors hover:bg-slate-50 hover:text-[#48247f]"
//                   >
//                     Solutions
//                     <ChevronDown
//                       size={16}
//                       strokeWidth={2.5}
//                       className={`transition-transform duration-200 ${
//                         mobileSolutionsOpen ? "rotate-180" : ""
//                       }`}
//                     />
//                   </button>

//                   <div
//                     className={`overflow-hidden transition-all duration-300 ${
//                       mobileSolutionsOpen
//                         ? "max-h-[400px] opacity-100"
//                         : "max-h-0 opacity-0"
//                     }`}
//                   >
//                     <div className="ml-2 mt-1 space-y-0.5 border-l-2 border-[#48247f]/15 pl-2">
//                       {solutionItems.map((solution) => {
//                         const Icon = solution.icon;
//                         return (
//                           <Link
//                             key={solution.label}
//                             to={solution.href}
//                             onClick={closeMobileMenu}
//                             className="flex items-center gap-2.5 rounded-lg px-3 py-2 text-[13.5px] font-medium text-slate-600 transition-colors hover:bg-[#f6f2ff] hover:text-[#48247f]"
//                           >
//                             <Icon size={15} strokeWidth={2.25} />
//                             {solution.label}
//                           </Link>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 </div>
//               );
//             }

//             return (
//               <Link
//                 key={item.label}
//                 to={item.path}
//                 onClick={closeMobileMenu}
//                 className={`block rounded-lg px-3 py-2.5 text-[14.5px] font-semibold tracking-[0.01em] transition-colors ${
//                   isActive(item.path)
//                     ? "bg-[#f6f2ff] text-[#48247f]"
//                     : "text-slate-700 hover:bg-slate-50 hover:text-[#48247f]"
//                 }`}
//               >
//                 {item.label}
//               </Link>
//             );
//           })}
//         </div>

//         <div className="border-t border-slate-100 p-4">
//           <div className="grid grid-cols-2 gap-2">
//             <Link
//               to="/login"
//               onClick={closeMobileMenu}
//               className="flex items-center justify-center rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-[14px] font-semibold tracking-[0.01em] text-slate-700 transition-colors hover:border-[#48247f]/30 hover:text-[#48247f]"
//             >
//               Sign in
//             </Link>
//             <Link
//               to="/register"
//               onClick={closeMobileMenu}
//               className="flex items-center justify-center gap-1.5 rounded-lg bg-[#12dfbd] px-3 py-2.5 text-[14px] font-bold tracking-[0.015em] text-[#102b37] shadow-[0_2px_10px_rgba(18,223,189,0.3)] transition-all hover:bg-[#40f0d3]"
//             >
//               Get started
//               <ArrowUpRight size={14} strokeWidth={2.75} />
//             </Link>
//           </div>
//         </div>
//       </aside>
//     </>
//   );
// };

// export default PublicHeader;










import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Menu,
  X,
  ChevronDown,
  ArrowUpRight,
  Shield,
  BookOpen,
  Landmark,
  Home,
  ShieldCheck,
  Cpu,
} from "lucide-react";

import LOGO from "../../src/assets/logolmsbts3.png";

const solutionItems = [
  { label: "Healthcare", href: "/solutions/healthcare", icon: Shield },
  { label: "Education", href: "/solutions/education", icon: BookOpen },
  { label: "Banking & Finance", href: "/solutions/banking-finance", icon: Landmark },
  { label: "Real Estate", href: "/solutions/real-estate", icon: Home },
  { label: "Insurance", href: "/solutions/insurance", icon: ShieldCheck },
  { label: "Technology", href: "/solutions/technology", icon: Cpu },
];

const navItems = [
  { label: "Features", path: "/features" },
  { label: "Solutions", path: "/solutions", dropdown: true },
  { label: "Pricing", path: "/pricing" },
  { label: "Blogs", path: "/blogs" },
  { label: "About Us", path: "/about-us" },
  { label: "Contact Us", path: "/contact" },
];

const PublicHeader = () => {
  const location = useLocation();
  const headerRef = useRef(null);

  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);
  const [mobileSolutionsOpen, setMobileSolutionsOpen] = useState(false);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return (
      location.pathname === path ||
      location.pathname.startsWith(`${path}/`)
    );
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
    setIsSolutionsOpen(false);
    setMobileSolutionsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsSolutionsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const closeMobileMenu = () => {
    setIsMenuOpen(false);
    setMobileSolutionsOpen(false);
  };

  return (
    <>
      <header
        ref={headerRef}
        className={`fixed inset-x-0 top-0 z-50 font-[Inter,ui-sans-serif,system-ui,sans-serif] antialiased transition-all duration-300 ${
          scrolled
            ? "bg-white/90 shadow-[0_4px_24px_rgba(40,25,79,0.08)] backdrop-blur-xl"
            : "bg-white border-b border-slate-100"
        }`}
      >
        {/* Thin brand accent with subtle glow */}
        <div className="h-[2.5px] w-full bg-gradient-to-r from-[#28194f] via-[#48247f] to-[#702cb0] shadow-[0_0_8px_rgba(72,36,127,0.35)]" />

        <nav
          className="mx-auto flex h-[60px] w-full max-w-[1600px] items-center justify-between px-4 sm:px-6 lg:h-[68px] lg:px-8 xl:px-12"
          aria-label="Main navigation"
        >
          {/* Logo */}
          <Link
            to="/"
            className="group relative z-50 flex shrink-0 items-center gap-2 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2"
            aria-label="LMSBOTS home"
          >
            <img
              src={LOGO}
              alt="LMSBOTS"
              className="h-8 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.04] sm:h-9 lg:h-[38px]"
            />
          </Link>

          {/* Desktop navigation */}
          <div className="hidden items-center gap-0.5 lg:flex">
            {navItems.map((item) => {
              if (item.dropdown) {
                return (
                  <div className="relative" key={item.label}>
                    <button
                      type="button"
                      onClick={() => setIsSolutionsOpen((open) => !open)}
                      onMouseEnter={() => setIsSolutionsOpen(true)}
                      aria-expanded={isSolutionsOpen}
                      className={`group relative inline-flex items-center gap-1 rounded-lg px-3.5 py-2 text-[14px] font-semibold tracking-[0.01em] transition-colors ${
                        isSolutionsOpen || isActive(item.path)
                          ? "text-[#48247f]"
                          : "text-slate-600 hover:text-[#48247f]"
                      }`}
                    >
                      <span className="relative">
                        {item.label}
                        <span
                          className={`absolute -bottom-1 left-0 h-[2px] rounded-full bg-gradient-to-r from-[#48247f] to-[#702cb0] transition-all duration-300 ${
                            isSolutionsOpen || isActive(item.path)
                              ? "w-full opacity-100"
                              : "w-0 opacity-0 group-hover:w-full group-hover:opacity-100"
                          }`}
                        />
                      </span>
                      <ChevronDown
                        size={15}
                        strokeWidth={2.5}
                        className={`text-current/60 transition-transform duration-200 ${
                          isSolutionsOpen ? "rotate-180" : ""
                        }`}
                      />
                    </button>

                    {isSolutionsOpen && (
                      <div
                        onMouseLeave={() => setIsSolutionsOpen(false)}
                        className="absolute left-1/2 top-full z-50 mt-2 w-[380px] -translate-x-1/2 overflow-hidden rounded-2xl border border-slate-200/70 bg-white p-2 shadow-[0_20px_60px_rgba(40,25,79,0.15)] animate-in fade-in slide-in-from-top-1 duration-150"
                      >
                        <div className="grid grid-cols-2 gap-1">
                          {solutionItems.map((solution) => {
                            const Icon = solution.icon;
                            return (
                              <Link
                                key={solution.label}
                                to={solution.href}
                                onClick={() => setIsSolutionsOpen(false)}
                                className="group flex items-center gap-2.5 rounded-xl px-3 py-2.5 transition-all duration-200 hover:bg-[#f6f2ff]"
                              >
                                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-slate-100 bg-white text-[#48247f] shadow-sm transition-all duration-200 group-hover:-translate-y-0.5 group-hover:border-[#48247f]/20 group-hover:bg-gradient-to-br group-hover:from-[#f3edff] group-hover:to-[#e9deff] group-hover:shadow-md">
                                  <Icon size={15} strokeWidth={2.25} />
                                </span>
                                <span className="text-[13.5px] font-semibold tracking-[0.005em] text-slate-700 transition-colors group-hover:text-[#48247f]">
                                  {solution.label}
                                </span>
                              </Link>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                );
              }

              return (
                <Link
                  key={item.label}
                  to={item.path}
                  className={`group relative rounded-lg px-3.5 py-2 text-[14px] font-semibold tracking-[0.01em] transition-colors ${
                    isActive(item.path)
                      ? "text-[#48247f]"
                      : "text-slate-600 hover:text-[#48247f]"
                  }`}
                >
                  <span className="relative">
                    {item.label}
                    <span
                      className={`absolute -bottom-1 left-0 h-[2px] rounded-full bg-gradient-to-r from-[#48247f] to-[#702cb0] transition-all duration-300 ${
                        isActive(item.path)
                          ? "w-full opacity-100"
                          : "w-0 opacity-0 group-hover:w-full group-hover:opacity-100"
                      }`}
                    />
                  </span>
                </Link>
              );
            })}
          </div>

          {/* Desktop actions */}
          <div className="hidden shrink-0 items-center gap-2 lg:flex">
            <Link
              to="/login"
              className="rounded-lg px-3.5 py-2 text-[14px] font-semibold tracking-[0.01em] text-slate-600 transition-colors hover:text-[#48247f]"
            >
              Sign in
            </Link>

            <Link
              to="/register"
              className="group relative inline-flex items-center gap-1.5 overflow-hidden rounded-lg bg-[#12dfbd] px-4 py-2 text-[14px] font-bold tracking-[0.015em] text-[#102b37] shadow-[0_2px_10px_rgba(18,223,189,0.3)] transition-all duration-200 hover:bg-[#40f0d3] hover:shadow-[0_6px_20px_rgba(18,223,189,0.45)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2"
            >
              <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
              <span className="relative">Get started</span>
              <ArrowUpRight
                size={15}
                strokeWidth={2.75}
                className="relative transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </Link>
          </div>

          {/* Mobile toggle */}
          <button
            type="button"
            onClick={() => setIsMenuOpen((open) => !open)}
            className="relative z-50 flex h-9 w-9 items-center justify-center rounded-lg text-slate-700 transition-colors hover:bg-slate-100 hover:text-[#48247f] lg:hidden"
            aria-label={isMenuOpen ? "Close navigation" : "Open navigation"}
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <X size={20} strokeWidth={2.25} /> : <Menu size={20} strokeWidth={2.25} />}
          </button>
        </nav>
      </header>

      {/* Mobile backdrop */}
      <div
        onClick={closeMobileMenu}
        className={`fixed inset-0 z-40 bg-slate-950/40 backdrop-blur-[3px] transition-opacity duration-300 lg:hidden ${
          isMenuOpen ? "visible opacity-100" : "invisible opacity-0"
        }`}
      />

      {/* Mobile navigation */}
      <aside
        className={`fixed bottom-0 right-0 top-0 z-40 flex w-full max-w-[360px] flex-col bg-white font-[Inter,ui-sans-serif,system-ui,sans-serif] shadow-2xl transition-transform duration-300 ease-out lg:hidden ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
        aria-hidden={!isMenuOpen}
      >
        <div className="h-[2.5px] shrink-0 bg-gradient-to-r from-[#28194f] via-[#48247f] to-[#702cb0]" />

        <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3.5">
          <img src={LOGO} alt="LMSBOTS" className="h-8 w-auto object-contain" />
          <button
            type="button"
            onClick={closeMobileMenu}
            className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-600 transition-colors hover:bg-slate-100 hover:text-[#48247f]"
            aria-label="Close menu"
          >
            <X size={19} strokeWidth={2.25} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-3 py-4">
          {navItems.map((item) => {
            if (item.dropdown) {
              return (
                <div key={item.label}>
                  <button
                    type="button"
                    onClick={() => setMobileSolutionsOpen((open) => !open)}
                    className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left text-[14.5px] font-semibold tracking-[0.01em] text-slate-700 transition-colors hover:bg-slate-50 hover:text-[#48247f]"
                  >
                    Solutions
                    <ChevronDown
                      size={16}
                      strokeWidth={2.5}
                      className={`transition-transform duration-200 ${
                        mobileSolutionsOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      mobileSolutionsOpen
                        ? "max-h-[400px] opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="ml-2 mt-1 space-y-0.5 border-l-2 border-[#48247f]/15 pl-2">
                      {solutionItems.map((solution) => {
                        const Icon = solution.icon;
                        return (
                          <Link
                            key={solution.label}
                            to={solution.href}
                            onClick={closeMobileMenu}
                            className="flex items-center gap-2.5 rounded-lg px-3 py-2 text-[13.5px] font-medium text-slate-600 transition-colors hover:bg-[#f6f2ff] hover:text-[#48247f]"
                          >
                            <Icon size={15} strokeWidth={2.25} />
                            {solution.label}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            }

            return (
              <Link
                key={item.label}
                to={item.path}
                onClick={closeMobileMenu}
                className={`block rounded-lg px-3 py-2.5 text-[14.5px] font-semibold tracking-[0.01em] transition-colors ${
                  isActive(item.path)
                    ? "bg-[#f6f2ff] text-[#48247f]"
                    : "text-slate-700 hover:bg-slate-50 hover:text-[#48247f]"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>

        <div className="border-t border-slate-100 p-4">
          <div className="grid grid-cols-2 gap-2">
            <Link
              to="/login"
              onClick={closeMobileMenu}
              className="flex items-center justify-center rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-[14px] font-semibold tracking-[0.01em] text-slate-700 transition-colors hover:border-[#48247f]/30 hover:text-[#48247f]"
            >
              Sign in
            </Link>
            <Link
              to="/register"
              onClick={closeMobileMenu}
              className="flex items-center justify-center gap-1.5 rounded-lg bg-[#12dfbd] px-3 py-2.5 text-[14px] font-bold tracking-[0.015em] text-[#102b37] shadow-[0_2px_10px_rgba(18,223,189,0.3)] transition-all hover:bg-[#40f0d3]"
            >
              Get started
              <ArrowUpRight size={14} strokeWidth={2.75} />
            </Link>
          </div>
        </div>
      </aside>
    </>
  );
};

export default PublicHeader;